export default {
  GET_DISCLOSURE_DATA: {
    url: '/data-record/list',
    method: 'GET'
  },
  GET_DISCLOSURE_DETAIL: {
    url: '/data-record/detail/',
    method: 'GET'
  },
  GET_PATIENT_DATA: {
    url: '/data-patient',
    method: 'GET'
  },
  GET_PATIENT_DETAIL: {
    url: '/data-patient',
    method: 'GET'
  },
  GET_YEARS_LIST: {
    url: '/data-record/public/get-year',
    method: 'GET'
  },
  GET_ROOT_SECTIONS: {
    url: '/section/public/root-section-list',
    method: 'GET'
  },
  GET_SUMMARY_DATA: {
    url: '/data-record/public/summary',
    method: 'GET'
  },
  GET_SECTION_DETAIL_LIST: {
    url: '/data-record/public',
    method: 'GET'
  },
  GET_SEARCH_RESULT: {
    url: '/data-record/public/search',
    method: 'GET'
  },
  EXPORT_DATA: {
    url: '/data-record/export',
    method: 'GET'
  },
  DOWNLOAD_PDF: {
    url: '/data-record/public/download-file',
    method: 'GET'
  },
  DELETE_DATA_RECORD: {
    url: '/data-record/delete/',
    method: 'DELETE'
  },
  UPDATE_DATA_RECORD: {
    url: '/data-record/update',
    method: 'PUT'
  },
  CHECK_UPDATE_DATA_RECORD_PROGRESS: {
    url: '/data-record/check-update-progress',
    method: 'GET'
  },
  UPDATE_DATA_RECORD_TO_PREVIEW: {
    url: '/data-record/move-data-record',
    method: 'PUT'
  }
};
